import { AuthService } from 'src/app/shared/services/auth.service';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { StorageService } from './shared/services/storage.service';
import Cookies from 'js-cookie';

@Injectable({
  providedIn: 'root'
})
export class HtppInterceptorService implements HttpInterceptor {
  geturl: any = window.location.href;
  url = new URL(this.geturl);
  etsBuid: string;
  buId: string;



  constructor(private storageService: StorageService, private auth: AuthService) {
    this.etsBuid = this.auth.etsBuid;
    this.buId = this.auth.buId;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const ssoToken = Cookies.get('sso-wis-token-' + this.etsBuid , { domain: 'moveinsync.com' });
    if (ssoToken){
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${ssoToken}`
        }
      });
      req = req.clone({
        setParams: {
          loginEmpGuid: this.url.searchParams.get("guid") || localStorage.getItem('employee_guid'),
          loginBuid: this.buId,
          loginClient: this.url.searchParams.get("client") || localStorage.getItem('client'),
          client: this.url.searchParams.get("client") || localStorage.getItem('client'),
        }
      });
    }
    else if (localStorage.getItem('token')) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.storageService.getLocalStorage('token')}`
        }
      });
      req = req.clone({
        setParams: {
          loginEmpGuid: localStorage.getItem('employee_guid'),
          loginBuid: localStorage.getItem('bu_id'),
          loginClient: localStorage.getItem('client'),
          client: localStorage.getItem('client'),
        }
      });
    }
    return next.handle(req);
  }
}
